export default "__VITE_ASSET__7bf21b8d__"